import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link, useNavigate } from 'react-router-dom';

import Fetchable from '~/commons/components/util/Fetchable';
import useHttp from '~/commons/hooks/useHttp';
import { resolvePath } from '~/commons/helpers';
import env from '~/commons/config/env';
import Html from '~/commons/components/util/Html';

import Scroll from '../../layout/Scroll';
import Page from '../../layout/Page';
import AnswerChoices from '../../mods/AnswerChoices';

const PageAnswer = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const { stage: url, difficulty, refCode } = useParams();
  const { req } = useHttp();
  const [q, setQ] = useState(0);
  const [answered, setAnswered] = useState([]);
  const [choices, setChoices] = useState([]);
  const [showTip, setShowTip] = useState(false);
  const save = (stage, answer) => {
    const answers = [...answered, answer];

    req({
      url: '/api/answers',
      method: 'patch',
      data: {
        stage: stage._id,
        answers,
        drawedQ: stage.questions,
      },
    });
    setAnswered(answers);

    setTimeout(() => {
      if (q < stage.questions.length - 1) {
        setChoices([]);
        setQ(q + 1);
      } else {
        navigate('result');
      }
    }, 2000);
  };

  return (
    <Page>
      <Fetchable
        req={{
          url: '/api/answers',
          method: 'post',
          data: {
            stage: {
              url: `/${url}`,
              difficulty,
              refCode,
              drawQ: true,
            },
          },
        }}
      >
        {(stage) => {
          const qq = stage.questions[q];
          const {
            _id: qId, question, img: [img] = [], tip,
          } = stage.questions[q];
          const ansed = answered.find((a) => a.question === qId);
          const progress = Math.round((q / stage.questions.length) * 100);
          return (
            <div className="container">
              {i18n.pickLng(
                tip,
              ) && (
              <div className="col-md-auto col-auto d-md-none d-flex justify-content-end">
                <div
                  onClick={() => setShowTip(true)}
                  className="btn rounded-pill bg-white
                                shadow border-4 border-primary py-1 text-primary fw-bold
                                d-flex align-items-center justify-content-center mb-3"
                >
                  <img
                    className="px-1 pb-1"
                    style={{ height: '1.5rem' }}
                    src="/assets/img/tips2.png"
                    alt="Tip"
                  />
                  <span className="px-1">{t('pg.game.tips')}</span>
                </div>
              </div>
              )}
              <Scroll fillScreen>
                {showTip && (
                  <button
                    className="btn fw-bold  btn-rock-3 fontBorder d-md-block d-none"
                    type="button"
                    onClick={() => setShowTip(false)}
                  >
                    {t('pg.game.back')}
                  </button>
                )}
                <div className="row justify-content-center">
                  <div className="col-10">
                    {showTip ? (
                      <>
                        <div className="flex">
                          <h1 className="fw-bold mt-3">
                            {t('pg.game.stageTip')}
                            :
                          </h1>
                        </div>
                        <div className="pb-4">
                          <Html>{i18n.pickLng(tip)}</Html>
                        </div>
                        <div className="d-md-none d-flex justify-content-center">
                          <button
                            className="btn fw-bold  btn-rock-3 fontBorder "
                            type="button"
                            onClick={() => setShowTip(false)}
                          >
                            {t('pg.game.back')}
                          </button>
                        </div>

                      </>
                    ) : (
                      <>
                        <div className="mb-4">
                          <div className="row align-items-baseline">
                            <div className="col-12 col-sm d-flex">
                              <h1 className="fw-bold mt-3 mb-0">
                                {t('question')}
                                :
                              </h1>
                            </div>
                            <div className="col-12 col-sm">
                              <div className="d-flex align-items-center">
                                <div className="progress flex-fill">
                                  <div className="progress-bar" style={{ width: `${progress}%` }} />
                                </div>
                                <span className="fw-bold fs-4 ms-3">
                                  {progress}
                                  %
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <h5 className="col-md col-12 fw-bold mt-2 text-break text-wrap">
                              {`${q + 1}. ${i18n.pickLng(
                                question,
                              )}`}

                            </h5>
                            {i18n.pickLng(
                              tip,
                            ) && (
                              <div className="col-md-auto col-auto d-md-block d-none">
                                <div
                                  onClick={() => setShowTip(true)}
                                  className="btn rounded-pill bg-white
                                shadow border-4 border-primary py-1 text-primary fw-bold
                                d-flex align-items-center justify-content-center"
                                >
                                  <img
                                    className="px-1 pb-1"
                                    style={{ height: '1.5rem' }}
                                    src="/assets/img/tips2.png"
                                    alt="Tip"
                                  />
                                  <span className="px-1">{t('pg.game.tips')}</span>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          {/* question image */}
                          {img && (
                            <div className="col-12 col-md-5 pb-3">
                              <div className="ratio ratio-1x1 w-100">
                                <div className="border-skewed shadow">
                                  <div
                                    className="img-bg"
                                    style={{
                                      backgroundImage: `url("/uploads/${img.path}")`,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}

                          {/* choices */}
                          <div className="col-12 col-md">
                            <h5 className="fw-bold">
                              {t('pg.game.chooseOne', {
                                plural: qq?.answer?.length > 1 ? 's' : '',
                                number: qq?.answer?.length,

                              })}
                              :
                            </h5>
                            <AnswerChoices
                              question={qq}
                              answered={ansed?.answered}
                              chose={choices}
                              onClick={(a) => {
                                const multi = qq.answer.length > 1;
                                const picked = choices.find((c) => c === a) !== undefined;
                                let draft;

                                if (picked) {
                                  draft = choices.filter((c) => c !== a);
                                } else if (
                                  multi && qq.answer.length > choices.length
                                ) {
                                  draft = [...choices, a];
                                } else if (!multi) {
                                  draft = [a];
                                }

                                if (draft) setChoices(draft);
                              }}
                            />
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>

              </Scroll>
              <div className="text-center  position-relative answersBtnGrp">
                <button
                  className="btn mx-3 btn-rock-3-Shadow fontBorder"
                  type="button"
                  onClick={() => {
                    if (choices.length === 0) return;

                    save(stage, {
                      question: qId,
                      answered: choices,
                    });
                  }}
                >
                  {t('pg.game.next')}
                </button>
                <Link
                  className="btn mx-3 btn-rock-3-Shadow fontBorder"
                  to={resolvePath(env.lowMode ? '/game' : '..')}
                >
                  {t('pg.game.quit')}
                </Link>
              </div>
            </div>
          );
        }}
      </Fetchable>
    </Page>
  );
};

export default PageAnswer;
